declare global {
  interface Window {
    __ENV__?: Record<string, string>
  }
}

/**
 * Runtime configuration. Empty `CLIENT_BACKEND_URL` means "same origin", which
 * is what we want in dev (Vite proxies /api) and behind a reverse proxy.
 */
export const config = {
  BACKEND_URL: window.__ENV__?.CLIENT_BACKEND_URL || '/api',
}
